export const getAllowedMallCodes = (accountInfo) => {
  const mallCodeList = accountInfo && accountInfo.mallCodeList;
  return Array.isArray(mallCodeList) ? mallCodeList : [];
};

export const hasMallRestriction = (accountInfo) =>
  getAllowedMallCodes(accountInfo).length > 0;

export const getDefaultMallCode = (accountInfo) => {
  const allowedMallCodes = getAllowedMallCodes(accountInfo);
  return allowedMallCodes.length === 1 ? allowedMallCodes[0] : undefined;
};

export const filterAccessibleMalls = (malls = [], accountInfo) => {
  const allowedMallCodes = getAllowedMallCodes(accountInfo);
  if (allowedMallCodes.length === 0) {
    return malls;
  }

  return malls.filter((mall) => allowedMallCodes.includes(mall.code));
};

export const canAccessMall = (accountInfo, mallCode) => {
  const allowedMallCodes = getAllowedMallCodes(accountInfo);
  return allowedMallCodes.length === 0 || allowedMallCodes.includes(mallCode);
};
